import Dialog from '$tablet-app/src/app/components/Dialog';
import DialogBottomActions from '$tablet-app/src/app/components/Dialog/DialogBottomActions';
import DialogHeader from '$tablet-app/src/app/components/Dialog/DialogHeader';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { startVoiceListening } from '$tablet-app/src/app/speech-to-text/useSTT';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { useCurrentUser } from '$tablet-app/src/app/users';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { useBool } from '@akin-home/utils/react';
import { PortalHost } from '@gorhom/portal';
import { useState } from 'react';
import { NativeSyntheticEvent, TextInputKeyPressEventData } from 'react-native';
import styled from 'styled-components/native';
import { useFocusedChatState } from '../../hooks/useFocusedChatState';
import { ChatAvatar } from './ChatAvatar';
import { FocusedChatWindowView } from './FocusedChatWindowView';

/**
 * Focused chat window provides a focused view of the chat with an intependent session from the rest of the chat
 */
export function FocusedChatWindow() {
  const [input, setInput] = useState('');

  const [
    close_confirmation_visible,
    showCloseConfirmation,
    hideCloseConfirmation,
  ] = useBool();

  /** Global State */
  const current_user = useCurrentUser();
  const closeFocusedChat = useFocusedChatState((state) => state.close);
  const microphone_active = useStateStore((state) => state.listening_to_voice);
  const selectChatOption = useFocusedChatState((state) => state.selectOption);

  const chat_items = useFocusedChatState((state) => state.chat_items);
  const sendMessage = useFocusedChatState((state) => state.sendMessage);

  const onPressSend = () => {
    if (!input.length) return;

    sendMessage(input);
    setInput('');
  };

  function closeChat() {
    closeFocusedChat();
  }

  

  return (
    <>
      <FocusedChatWindowView
        user={current_user}
        state={{ input, microphone_active, chat_items }}
        // Components
        avatar={<ChatAvatar />}
        // Input Changes
        onChangeInput={setInput}
        // Button Presses
        onPressMicrophone={startVoiceListening}
        onPressSend={onPressSend}
        onPressOption={selectChatOption}
        onPressClose={showCloseConfirmation}
      />

      <PortalHost name="focused-chat-portal" />

      {close_confirmation_visible && (
        <Dialog>
          <DialogHeader
            center={
              <Text weight="semibold">Are you sure you want to leave?</Text>
            }
          />

          <ConfirmationCloseBody>
            <Text>We can complete this conversation later if you want</Text>
          </ConfirmationCloseBody>

          <DialogBottomActions>
            <Button onPress={hideCloseConfirmation}>No, stay here</Button>
            <Spacer width="16px" />
            <Button onPress={closeChat}>Yes, leave this chat</Button>
          </DialogBottomActions>
        </Dialog>
      )}
    </>
  );
}

const ConfirmationCloseBody = styled.View`
  padding: 16px;
`;
